<template>
	<div class="content-box">
		<el-tabs v-model="activeName" v-if="hasGetTableDataModel">
			<el-tab-pane label="待退库" name="recv">
				<wait-recv v-if="activeName=='recv'"></wait-recv>
			</el-tab-pane>
			<el-tab-pane label="退库记录" name="his">
				<his v-if="activeName=='his'" :type="[22]"></his>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Inventory from "@/mixinsApp/Inventory.js";
import WaitRecv from "@/views/Inventory/subs/WaitRecv.vue";
import TabPage from "@/mixins/TabPage.js";

export default {
	mixins: [Inventory, TabPage],
	components: {
		WaitRecv
	},
	data() {
		return {
			activeName: "recv",
			fields: [
				{
					name: "warehouse"
				},
				{
					name: "customer",
					params: {
						type: "Agent"
					}
				},
				{
					name: "show_id"
				},
				{
					name: "express"
				},
				{
					name: "tracking_number"
				},
				{
					name: "discount"
				},
				{
					name: "express_fee"
				}
			],
			info: {
				warehouse: {
					name: "",
					_id: ""
				},
				customer: {
					name: "",
					_id: "",
					agent_level: 0,
					type: 1
				},
				order: {
					name: "",
					_id: ""
				},
				show_id: "",
				items: [],
				express_fee: 0,
				discount: 0
			}
		};
	},
	computed: {},
	methods: {
		doResetAll() {
			this.info = {
				warehouse: {
					name: "",
					_id: ""
				},
				customer: {
					name: "",
					_id: "",
					agent_level: 0,
					type: 1
				},
				show_id: "",
				items: [],
				express_fee: 0,
				discount: 0
			};
		}
	}
};
</script>